import { normalizarCnpj } from "./cnpjValidator";

export const applyCpfCnpjMask = (value, isCpfOnly = false) => {
  const onlyNumbers = normalizarCnpj(value);

  if (isCpfOnly) {
    if (onlyNumbers.length <= 3) return onlyNumbers;
    if (onlyNumbers.length <= 6)
      return `${onlyNumbers.slice(0, 3)}.${onlyNumbers.slice(3)}`;
    if (onlyNumbers.length <= 9)
      return `${onlyNumbers.slice(0, 3)}.${onlyNumbers.slice(
        3,
        6,
      )}.${onlyNumbers.slice(6)}`;
    return `${onlyNumbers.slice(0, 3)}.${onlyNumbers.slice(
      3,
      6,
    )}.${onlyNumbers.slice(6, 9)}-${onlyNumbers.slice(9, 11)}`;
  }

  if (onlyNumbers.length <= 2) return onlyNumbers;
  if (onlyNumbers.length <= 5)
    return `${onlyNumbers.slice(0, 2)}.${onlyNumbers.slice(2)}`;
  if (onlyNumbers.length <= 8)
    return `${onlyNumbers.slice(0, 2)}.${onlyNumbers.slice(
      2,
      5,
    )}.${onlyNumbers.slice(5)}`;
  if (onlyNumbers.length <= 12)
    return `${onlyNumbers.slice(0, 2)}.${onlyNumbers.slice(
      2,
      5,
    )}.${onlyNumbers.slice(5, 8)}/${onlyNumbers.slice(8)}`;
  return `${onlyNumbers.slice(0, 2)}.${onlyNumbers.slice(
    2,
    5,
  )}.${onlyNumbers.slice(5, 8)}/${onlyNumbers.slice(8, 12)}-${onlyNumbers.slice(
    12,
    14,
  )}`;
};

export const applyRgMask = (value) => {
  if (!value) return "";

  // Remove tudo que não for número
  const numbers = value.replace(/\D/g, "").slice(0, 9);

  return numbers
    .replace(/^(\d{2})(\d)/, "$1.$2")
    .replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3")
    .replace(/^(\d{2})\.(\d{3})\.(\d{3})(\d)/, "$1.$2.$3-$4");
};

export const applyPhoneMask = (value) => {
  const onlyNumbers = value.replace(/\D/g, "");

  if (onlyNumbers.length <= 2) return `(${onlyNumbers}`;
  if (onlyNumbers.length <= 6)
    return `(${onlyNumbers.slice(0, 2)}) ${onlyNumbers.slice(2)}`;
  if (onlyNumbers.length === 10)
    return `(${onlyNumbers.slice(0, 2)}) ${onlyNumbers.slice(
      2,
      6,
    )}-${onlyNumbers.slice(6)}`;
  return `(${onlyNumbers.slice(0, 2)}) ${onlyNumbers.slice(
    2,
    7,
  )}-${onlyNumbers.slice(7)}`;
};

export const applyCepMask = (value) => {
  const digits = value.replace(/\D/g, "");
  if (digits.length > 5) {
    return digits.substring(0, 5) + "-" + digits.substring(5, 8);
  }
  return digits;
};

export const applyCpfMask = (value) => {
  const digits = value.replace(/\D/g, "");
  if (digits.length > 3) {
    return digits.substring(0, 3) + "." + digits.substring(3, 6);
  }
  return digits;
};
